class RelatedProductsSlider extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('recommendationsLoaded', this.handleRecommendationsLoaded.bind(this));

  }
  handleRecommendationsLoaded() {
    this.initSlider();
  }

  initSlider() {
    this.slider = this.querySelector('.product-grid--slider');
    if (!this.slider) {
      console.error('Slider or slider component element not found');
      return;
    }

    const showDesktopSlider = this.dataset.desktopSlide === 'true';
    const showMobileSlider = this.dataset.mobileSlide === 'true';

    if (showDesktopSlider && showMobileSlider) {
      this.buttonNext = this.querySelector('[btn-next]');
      this.buttonPrev = this.querySelector('[btn-prev]');
      this.desktopColumns = parseInt(this.slider.getAttribute('data-desktop-column'), 10);
      this.productItems = this.slider.querySelectorAll('li').length;

      if (this.productItems > this.desktopColumns) {
        this.initSwiper();
      }
    }
  }

  initSwiper() {
    if (!this.slider) {
      console.error('Slider element not found for Swiper initialization');
      return;
    }
    console.log(this.buttonNext);
    console.log(this.buttonPrev);

    const swiper = new Swiper(this.querySelector('[swiper-slider]'), {
      slidesPerView: 'auto',
      touchRatio: 1,
      speed: 800,
      loop: false,
      spaceBetween: 20,
      shortSwipes: true,
      allowTouchMove: true,
      simulateTouch: true,
      mousewheel: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
    },
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev,
      },
      breakpoints: {
        0: {
          spaceBetween: 12,
        },
        750: {
          spaceBetween: 20,
        },
      },
    });

  }
}

customElements.define('related-products-slider', RelatedProductsSlider);